<template>
    <LayoutPage :nav-bar-show-logo-text="navBarShowLogoText">
      <page-breadcrumb :hierarchy="breadCrumbs"/>

        <div v-if="!contactUsFormSuccess" class="container">

            <slot/>

            <p class="pb-2 pt-2 font-extrabold">
                If you’ve got a query about our service, then why not get in touch?
            </p>
            <div class="flex flex-col md:gap-8 md:flex-row">

                <div class="w-full">
                    <h2 class="font-large font-bold text-blue-60 text-2xl py-4 lg:text-left lg:text-3xl">
                        Telephone us
                    </h2>
                    <p class="p-4 mb-4 font-bold rounded-lg bg-grey-20">
                        0330 380 0025
                    </p>
                </div>
                <div class="w-full">
                    <h2 class="font-large font-extrabold text-blue-60 text-2xl py-4 lg:text-left lg:text-3xl">
                        or, Contact us by email
                    </h2>

                    <ContactUsForm
                        :parameters="parameters"
                        :errors="errors"
                        :submitting="submitting"
                        @changeParameter="(payload) => setParameter(payload)"
                        @submit="submitForm"
                    />
                </div>
            </div>
        </div>

        <div v-else class="container">
            <h3 class="font-large text-blue-60 text-2xl py-4 lg:text-left lg:text-3xl">
                Email Received
            </h3>
            <p class="pt-3">
                Thank you for your enquiry. If you have any questions please feel free to contact us on
                <a href="tel:03303800025" class="font-bold">0330&nbsp;380&nbsp;0025</a>
                during normal office hours.
            </p>
            <p class="pt-3 pb-3">
                The following has been sent to the relevant department:
            </p>
            <div class="grid grid-cols-[120px_1fr] gap-2">
                <div>Name</div>
                <div class="bg-grey-20 p-1">{{ parameters.name }}</div>

                <div>Company</div>
                <div class="bg-grey-20 p-1">{{ parameters.company }}</div>

                <div>Website</div>
                <div class="bg-grey-20 p-1">{{ parameters.website }}</div>

                <div>Email</div>
                <div class="bg-grey-20 p-1">{{ parameters.email }}</div>

                <div>Telephone</div>
                <div class="bg-grey-20 p-1">{{ parameters.telephone }}</div>

                <div>Subject</div>
                <div class="bg-grey-20 p-1">{{ parameters.subject }}</div>

                <div>Enquiry</div>
                <div class="bg-grey-20 p-1">{{ parameters.enquiry }}</div>
            </div>
        </div>
    </LayoutPage>
</template>

<script>
import ContactUsForm from 'Components/ContactUsForm.vue';
import LayoutPage from 'Components/layouts/LayoutPage.vue';
import PageBreadcrumb from 'Components/PageBreadcrumb.vue';
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
    name: 'ContactUsPage',
    props: {
        navBarShowLogoText: {
            type: Boolean,
            default: true,
        },
        formType: {
            type: String,
            required: true,
        }
    },
    components: {ContactUsForm, PageBreadcrumb, LayoutPage},
    computed: {
        ...mapState('contactUs', ['errors', 'parameters', 'submitting']),
        ...mapState('contactUs', {'contactUsFormSuccess': 'success'}),
        breadCrumbs : function(){
          return [
            {
              name: 'Online Recruitment Advertising'
            }
          ]
        }
    },
    methods: {
        ...mapActions('contactUs', ['submitContactUsForm']),
        ...mapMutations('contactUs', ['resetState', 'setParameter']),
        submitForm() {
            this.setParameter({key: 'formType', value: this.formType});
            this.submitContactUsForm();
        }
    },
    mounted() {
        // Reset the contact form state on page load so the user can submit again
        this.resetState();
    },
};
</script>
